import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4746dda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex-container" }
const _hoisted_3 = {
  key: 0,
  class: "uk-align-center uk-text-center uk-text-bold"
}
const _hoisted_4 = {
  key: 1,
  class: "uk-align-center uk-text-center uk-text-bold"
}
const _hoisted_5 = {
  key: 0,
  class: "uk-align-center uk-text-center uk-text-bold"
}
const _hoisted_6 = {
  key: 0,
  class: "uk-align-center uk-text-center uk-text-bold"
}
const _hoisted_7 = {
  key: 1,
  class: "uk-align-center uk-text-center uk-text-bold"
}
const _hoisted_8 = { class: "uk-text-bold uk-text-center" }
const _hoisted_9 = {
  key: 0,
  class: "spinner"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "uk-text-bold running-text" }, "Running", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "uk-align-center uk-text-center uk-text-warning uk-text-bold"
}
const _hoisted_13 = {
  key: 2,
  class: "uk-align-center uk-text-center uk-text-success uk-text-bold"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "uk-align-center uk-text-center uk-text-danger uk-text-bold"
}
const _hoisted_16 = {
  key: 2,
  class: "uk-align-center uk-text-center uk-text-success uk-text-bold"
}
const _hoisted_17 = { class: "spinner-sync" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_ctx.dataSource !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_DxDataGrid, {
          "data-source": _ctx.dataSource,
          class: "logs uk-align-center",
          ref: _ctx.gridRefName,
          "show-borders": true,
          "column-auto-width": true,
          "row-alternation-enabled": true,
          "allow-column-resizing": true,
          "on-cell-prepared": _ctx.onCellPrepared
        }, {
          refresh: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_DxButton, {
                width: 170,
                hint: "Refresh",
                text: "Refresh",
                icon: "refresh",
                type: "default",
                "styling-mode": "contained",
                onClick: _ctx.refreshTable
              }, null, 8, ["onClick"])
            ])
          ]),
          dateTemplate: _withCtx(({data}) => [
            (data.value !== null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.formatDate(data.value)), 1))
              : _createCommentVNode("", true),
            (data.value === null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Waiting..."))
              : _createCommentVNode("", true)
          ]),
          timeTemplate: _withCtx(({data}) => [
            (data.value !== null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.formatTime(data.value)), 1))
              : _createCommentVNode("", true)
          ]),
          timeRunning: _withCtx(({data}) => [
            (data.data.isFinished !== true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.formatTimeDifference(data.value)), 1))
              : _createCommentVNode("", true),
            (data.data.isFinished === true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.formatTimeDifferenceFinished(data.data.timeStarted, data.data.dateFinished)), 1))
              : _createCommentVNode("", true)
          ]),
          "normal-header": _withCtx(({data}) => [
            _createElementVNode("span", _hoisted_8, _toDisplayString(data.column.caption), 1)
          ]),
          status: _withCtx(({data}) => [
            (data.value === false)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            (data.value === null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'pause'] }),
                  _createTextVNode(" Queued")
                ]))
              : _createCommentVNode("", true),
            (data.value === true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'check'] }),
                  _createTextVNode(" Done")
                ]))
              : _createCommentVNode("", true)
          ]),
          success: _withCtx(({data}) => [
            (data.value === null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14))
              : _createCommentVNode("", true),
            (data.value === false)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'times'] })
                ]))
              : _createCommentVNode("", true),
            (data.value === true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'check'] })
                ]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DxScrolling, { mode: "virtual" }),
            _createVNode(_component_DxColumn, {
              "data-field": "isFinished",
              "cell-template": "status",
              "header-cell-template": "normal-header",
              caption: "Status"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "dateStarted",
              "cell-template": "dateTemplate",
              "header-cell-template": "normal-header",
              caption: "Date"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "timeStarted",
              "cell-template": "timeTemplate",
              "header-cell-template": "normal-header",
              caption: "Time Started"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "dateFinished",
              "cell-template": "timeTemplate",
              "header-cell-template": "normal-header",
              caption: "Time Finished"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "secondsPast",
              "header-cell-template": "normal-header",
              caption: "Time Elapsed",
              "cell-template": "timeRunning"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "isSuccessful",
              "header-cell-template": "normal-header",
              caption: "Was Successful",
              "cell-template": "success"
            }),
            _createVNode(_component_DxToolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, {
                  location: "after",
                  template: "refresh"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-source", "on-cell-prepared"]),
        _withDirectives(_createVNode(_component_DxButton, {
          class: "run-button-css",
          width: 120,
          hint: "Sync Tableau Template Workbooks",
          text: "Sync",
          icon: "pulldown",
          type: "default",
          "styling-mode": "outlined",
          onClick: _ctx.refreshTemplateWorkbooks,
          disabled: this.dataSource.length <= 0
        }, null, 8, ["onClick", "disabled"]), [
          [_vShow, !_ctx.startedRunning]
        ]),
        _withDirectives(_createElementVNode("span", _hoisted_17, null, 512), [
          [_vShow, _ctx.startedRunning]
        ])
      ]))
    : _createCommentVNode("", true)
}